<template>
  <div class="form-group--border">
      <div class="row">
          <div class="col-12 required">
            <component-input
                label="Наименование"
                placeholder="Введите наименование"
                v-model="item.name"
                required/>
          </div>
      </div>
      <div class="row mt-4">
          <div class="col-12">
            <component-input
                label="Описание"
                type="textarea"
                placeholder="Введите описание"
                v-model="item.description"
                required/>
          </div>
      </div>
      <div class="row mt-4">
          <div class="col-12 manual-upload">
            <label class='control-label'>Файл руководства</label>
            <file-upload width="100%" :entity="item"
                @deleteFile="removeFile"
                prop-name="file"
                @uploaded="fileUploaded"/>
            <div class="invalid-msg" v-if="v$.item.fileId.$error">Файл обязателен</div>
          </div>
      </div>
      <div>
          <div class="float-right d-flex align-items-center mt-4">
              <button-component class="btn btn-primary mx-2" v-on:click="save">Сохранить</button-component>
              <button-component type="button" kind="secondary" class="btn" v-on:click="close">Отмена</button-component>
          </div>
      </div>
  </div>
</template>

<script>
import ButtonComponent from "../../../common/ui/ButtonComponent";
import ComponentInput from "@/common/components/ComponentInput";
import FileUpload from "@/common/components/FileUpload";
import {useVuelidate} from "@vuelidate/core";
import {required} from "@vuelidate/validators";
export default {
  name: "EditManual",
  components: {ButtonComponent, ComponentInput, FileUpload},
  emits: ['save', 'close'],
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      item: {}
    }
  },
  created() {
    Object.assign(this.item, this.data);
  },
  methods: {
    save() {
      this.v$.$touch();
      if (this.v$.$invalid) {
        return;
      }
      this.$emit('save', this.item);
    },
    close() {
      this.$emit('close');
    },
    removeFile() {
      this.item.fileId = null;
      this.item.file = null;
    },
    fileUploaded(e) {
      this.item.file = e.data;
      this.item.fileId = e.data ? e.data.id : null;
    },
  },
  setup: () => ({v$: useVuelidate()}),
  validations() {
    return {
      item: {
        name: {required},
        description: {required},
        fileId: {required}
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.manual-upload::v-deep {
  .label-input {
    max-width: calc(100% - 75px);
  }
}
</style>